export default __webpack_public_path__ + "static/media/face_1_68.28c7636f.png";